module.exports = __webpack_public_path__ + "so.svg?f132fe50d871e1711794358e07ce0191";